export default __webpack_public_path__ + "media/flags/dz-72f4e712.svg";